module.exports = __webpack_public_path__ + "img/image6.1e3c3108.png";